export { default as InteractiveImageMap } from "./InteractiveImageMap";
